import axios from 'axios';
import { message } from 'antd';
import {
  LEDGER_API,
} from '../../../constants/API';
import {
  CREATE_LEDGER_LOADING
} from '../types';


function createLedger(data) {
  return async(dispatch, getState) => {
      dispatch({
        type: CREATE_LEDGER_LOADING,
        creatingLedger: true
      });
      try {
        const accessToken = await localStorage.getItem('accessToken');
        const { userData } = getState().AuthReducer;
        const postData = {
          ...data,
          userId: userData.id
        };
        await axios.post(LEDGER_API, postData, { headers: {"Authorization" : `Bearer ${accessToken}`} });

        dispatch({
          type: CREATE_LEDGER_LOADING,
          creatingLedger: false
        });
      } catch (e) {
        message.error(String(e));
        dispatch({
          type: CREATE_LEDGER_LOADING,
          creatingLedger: false
        });
        console.log(e);
      }
  }
}
export default createLedger;
